import { placeQueryCommandReducers } from './ngrx.stores/place.query.command/reducers';
import { PlaceCalendarRoutingModule } from './place-calendar-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CalendarSharedModule } from '../shared/calendar.shared.module';
import { PlaceDetailsComponent } from './components/place.details.modal/normal.place.details.modal/place.details.component';
import { FancyPlaceDetailsModalComponent } from './components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { OpeningHoursComponent } from './components/place.details.modal/opening.hours/opening.hours.component';
import { GooglePlaceReviewsComponent } from './components/google.place.reviews/google.place.reviews.component';
import { DineIconsComponent } from './components/place.details.modal/dine.icons/dine.icons.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StoreModule } from '@ngrx/store';
import { PlaceLocationFilterComponent } from './components/place.location.filter/place.location.filter.component';

@NgModule({
  declarations: [
    PlaceDetailsComponent,   
    // FancyPlaceDetailsModalComponent,
    // OpeningHoursComponent,
    // GooglePlaceReviewsComponent,
    // DineIconsComponent,
    // VisitorPlaceMapComponent,
    // CreatePlaceComponent,
    // EditPlaceCategoryModalComponent,
    // PlaceCategorySelectorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CalendarSharedModule,
    PlaceCalendarRoutingModule,
    ScrollingModule,

    StoreModule.forFeature('placeQueryCommand', placeQueryCommandReducers),
  ],
})
export class PlaceCalendarModule {}
